import apiClient from "./apiClient";
import { isOfflineMode } from "@/helpers/offlineMode";
import { VehicleDetailModel, VehicleExtraFilterParams, VehicleExtraOption } from "@/models/vehicle";

// Mirrors vehicleSearchByVRM in the twilio-flex-plugin-workscreens
// vehicle.service.ts — GET vehicles/search/by-vrm/{vrm}/{applicationId}.

const mockVehicleByVrm: VehicleDetailModel = {
  vehicleId: 900123,
  regNumber: "AB21 CDE",
  make: "Volkswagen",
  model: "Golf R-Line",
  trim: "1.5 TSI",
  colour: "Indigo Blue",
  mileage: 18000,
  price: 22995,
  year: 2021,
};

const vehicleSearchByVRM = async (
  registration: string,
  applicationId: number,
  postcode = "",
  dealerId?: number,
  signal?: AbortSignal
): Promise<VehicleDetailModel> => {
  if (isOfflineMode()) {
    return { ...mockVehicleByVrm, regNumber: registration.toUpperCase() };
  }
  const { data } = await apiClient.get<VehicleDetailModel>(
    `vehicles/search/by-vrm/${registration}/${applicationId}`,
    {
      params: {
        registration,
        postcode,
        ...(dealerId ? { dealerId } : {}),
      },
      signal,
    }
  );
  return data;
};

// Mirrors getVehicleExtraItemListFiltered in the workscreens vehicle.service.ts —
// POST vehicle-extras/options-filtered. Returns null when the vehicle has no extras.
const mockVehicleExtraOptions: VehicleExtraOption[] = [
  {
    vehicleExtraOptionId: 101,
    description: "3 Year Cosmetic and Alloy Repair",
    price: 699,
    isEmptyPlaceholder: false,
    isDisabled: false,
    isDeleted: false,
    paintPrice: 0,
    warrantyPrice: 0,
    cosmeticRepairPrice: 0,
    minPrice: 0,
    maxPrice: 0,
    vehicleExtraTypeId: 5,
    vehicleExtraTypeName: "Cosmetic Repair",
  },
  {
    vehicleExtraOptionId: 104,
    description: "1 Year Warranty",
    price: 1049,
    isEmptyPlaceholder: false,
    isDisabled: false,
    isDeleted: false,
    paintPrice: 0,
    warrantyPrice: 0,
    cosmeticRepairPrice: 0,
    minPrice: 15000.01,
    maxPrice: 25000,
    vehicleExtraTypeId: 3,
    vehicleExtraTypeName: "Warranty",
  },
  {
    vehicleExtraOptionId: 108,
    description: "2 Year Warranty",
    price: 1649,
    isEmptyPlaceholder: false,
    isDisabled: false,
    isDeleted: false,
    paintPrice: 0,
    warrantyPrice: 0,
    cosmeticRepairPrice: 0,
    minPrice: 15000.01,
    maxPrice: 25000,
    vehicleExtraTypeId: 3,
    vehicleExtraTypeName: "Warranty",
  },
  {
    vehicleExtraOptionId: 112,
    description: "3 Year Warranty",
    price: 2049,
    isEmptyPlaceholder: false,
    isDisabled: false,
    isDeleted: false,
    paintPrice: 0,
    warrantyPrice: 0,
    cosmeticRepairPrice: 0,
    minPrice: 15000.01,
    maxPrice: 25000,
    vehicleExtraTypeId: 3,
    vehicleExtraTypeName: "Warranty",
  },
];

const getVehicleExtraOptionsFiltered = async (
  params: VehicleExtraFilterParams,
  signal?: AbortSignal
): Promise<VehicleExtraOption[] | null> => {
  if (isOfflineMode()) return mockVehicleExtraOptions;
  const { data } = await apiClient.post<VehicleExtraOption[] | null>(
    "static/vehicle-extras/options-filtered",
    params,
    { signal }
  );
  return data;
};

export const vehicleService = {
  vehicleSearchByVRM,
  getVehicleExtraOptionsFiltered,
};
